(ns bp-clients.tv-app.common.components.highlights
  (:require
   [bp-clients.tv-app.utils.keycodes :as keycodes]
   [bp-clients.tv-app.utils.utils :as utils]
   [bp-libs.design-system.components.highlights :refer [tv-highlights]]
   [reagent.core :as r]))

(defn highlights
  "Highlights component wrapper to control navigation state.

  * Vertical navigation is treated outside this component, by
  vertical-scroll-with-lazy-rendering component.

  Horizontal navigation - Expected behaviour:
  - When the user is in the first item and clicks left, should open
  menu.

  - When the user is in the last item and clicks right, should do
  nothing.

  - The internal state (selected-card) is reseted when the user
  navigates down. This is because when focusing in highligths,
  the focus always goes to the first item."
  [items ignore-navigation? on-navigate]
  (let [items              (take 5 items)
        selected-card      (r/atom 0)
        ignore-navigation? (or ignore-navigation? (r/atom false))]
    (r/create-class
     {:reagent-render      (fn [_props]
                             [:div {:on-focus    #(reset! ignore-navigation? false)
                                    :on-key-down #(let [keyCode (-> % .-keyCode)]
                                                    (when (or (keycodes/left? keyCode) (keycodes/right? keyCode))
                                                      (utils/stop-event-propagation %)
                                                      (when on-navigate (on-navigate)))

                                                    (when-not @ignore-navigation?
                                                      (cond
                                                        (keycodes/down? keyCode)
                                                        (reset! selected-card 0)

                                                        (keycodes/left? keyCode)
                                                        (if (zero? @selected-card)
                                                          (.focus js/SpatialNavigation "menu")
                                                          (do
                                                            (reset! selected-card (dec @selected-card))
                                                            (.move js/SpatialNavigation "left")))

                                                        (keycodes/right? keyCode)
                                                        (when (< @selected-card (-> items count dec))
                                                          (reset! selected-card (inc @selected-card))
                                                          (.move js/SpatialNavigation "right"))

                                                        :else nil)))}
                              [tv-highlights items]])})))
